module.exports = __webpack_public_path__ + "img/P150T_weapon_30.8f0a7bcc.png";